module.exports = __webpack_public_path__ + "img/game-card-profile-icon-big-margins.18c4a78a.png";